module.exports = __webpack_public_path__ + "static/media/Picture1lora.c80c1fbf.jpg";